export enum TableSectionType {
  TODAY = "today",
  PREVIOUS_SEVEN = "previous_seven",
  EARLIER = "earlier",
}
